module.exports = __webpack_public_path__ + "img/ic_minus_white.0e2bdba4.svg";